export var CLASS_NAME_SHOW = 'show';
export var CLASS_NAME_FADE = 'fade';


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/constants/classes.js
// module id = M30R
// module chunks = 86